import Backbone from "backbone";
import PromisedSyncHoc from "scripts/hoc/promisedSyncHoc";

class BaseCollection extends PromisedSyncHoc(Backbone.Collection) {}

export default BaseCollection;
